<template>
    <div class="px-3 pt-3 pb-3">
        <v-row no-gutters dense>
            <v-col cols="12" sm="6" md="4"
                ><span class="label">{{ $t('Наименование КСК/ОСИ/ПТ') }}</span></v-col
            >
            <v-col cols="12" sm="6" md="8" class="d-flex">
                <span class="gray--text">{{ KSK && KSK.ksk_name ? KSK.ksk_name : '' }}</span>
            </v-col>
        </v-row>
        <v-row no-gutters dense>
            <v-col cols="12" sm="6" md="4"
                ><span class="label">{{ $t('БИН/ИИН') }}</span></v-col
            >
            <v-col cols="12" sm="6" md="8">
                <TextEdit :value="KSK.bin" fieldName="bin" methodName="updateksk" :keyRID="KSKRid" />
            </v-col>
        </v-row>
        <v-row no-gutters dense>
            <v-col cols="12" sm="6" md="4"
                ><span class="label">{{ $t('Председатель КСК/ОСИ/ПТ') }}</span></v-col
            >
            <v-col cols="12" sm="6" md="8">
                <TextEdit :value="KSK.chairman" fieldName="chairman" methodName="updateksk" :keyRID="KSKRid" />
            </v-col>
        </v-row>
        <v-row no-gutters dense>
            <v-col cols="12" sm="6" md="4"
                ><span class="label">{{ $t('Адрес') }}</span></v-col
            >
            <v-col cols="12" sm="6" md="8"
                ><span class="gray--text">{{ KSK.address_full_name }}</span></v-col
            >
        </v-row>
        <v-row no-gutters dense>
            <v-col cols="12" sm="6" md="4"
                ><span class="label">{{ $t('Административный район') }}</span></v-col
            >
            <v-col cols="12" sm="6" md="8"
                ><span class="gray--text">{{ KSK.district_name }}</span></v-col
            >
        </v-row>
        <v-row :v-if="contacts && contacts.length > 0"
            ><v-col cols="12">
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <span class="label"> {{ $t('Контакты') }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-btn color="primary" @click="showNew"
                                ><v-icon>mdi-phone-plus</v-icon><span>{{ $t('Добавить') }}</span></v-btn
                            >
                            <div class="mt-3">
                                <ContactAddEdit ref="addEditContact" @contactSaved="onContactSave" :contacts="newContact" :isNew="true" />
                            </div>
                            <v-row dense no-gutters class="mt-5">
                                <v-col cols="12" sm="12" md="6" v-for="x in contacts" :key="x.contact_type_name + '_' + x.contr_contact_value">
                                    <ContactAddEdit
                                        :contacts="{
                                            record_id: x.record_id,
                                            contact_type_rid: x.contact_type_rid,
                                            contact_type_name: x.contact_type_name,
                                            contr_contact_value: x.contact_value
                                        }"
                                        @contactSaved="onContactSave"
                                    />
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel> </v-expansion-panels
            ></v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <span class="label">{{ $t('Данные по домам КСК/ОСИ/ПТ') }}</span>
            </v-col>
        </v-row>
        <v-row no-gutters dense class="d-flex align-end justify-end">
            <KSKHousesFilter :KSKRid="KSKRid" />
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :options.sync="kskHousesPagination"
                    disable-sort
                    :loading="KSKHousesLoading"
                    :headers="KSKHousesHeader"
                    :items="KHLT"
                    :server-items-length="KSKHousesLenght"
                    :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [10, 15, 20, 25] }"
                >
                    <template v-slot:item.date_begin="{ item }">
                        <span>{{ item.date_begin | formatDate }}</span>
                    </template>
                    <template v-slot:item.date_end="{ item }">
                        <span>{{ item.date_end | formatDate }}</span>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import translate from '@/utils/translate.util';
import KSKHousesFilter from '@/components/ui/KSKHousesFilter.vue';
import TextEdit from '@/components/ui/TextEdit.vue';
import { getFilterArray, getFilterArrayWithDates } from '@/utils/filter.util';
import ContactAddEdit from './ui/ContactAddEdit.vue';
import moment from 'moment';
export default {
    data: () => ({
        KSKRid: 0,
        newContact: { contact_type_rid: null, contact_type_name: null, contr_contact_value: null }
    }),
    name: 'Contractor',
    components: { KSKHousesFilter, TextEdit, ContactAddEdit },
    computed: {
        ...mapState('request', ['KSKFullInfo', 'KSKContacts', 'KSKHousesLoading', 'KSKHousesLenght', 'KSKHousesList', 'KSKHousesPagination', 'Filter']),
        ...mapState('users', ['userInfo']),
        KSKHousesHeader: function() {
            return [
                {
                    text: this.$t('Адрес дома'),
                    value: 'isas_address_full_name'
                },
                {
                    text: this.$t('Административный район'),
                    value: 'district_name'
                },
                {
                    text: this.$t('Эксплуатационный район'),
                    value: 'exploative_district_name'
                },
                {
                    text: this.$t('Тепловой участок'),
                    value: 'heat_area'
                },
                {
                    text: this.$t('Количество лицевых счетов'),
                    value: 'accounts_count'
                },
                {
                    text: this.$t('Общая площадь'),
                    value: 'total_square'
                },
                {
                    text: this.$t('Инженер района'),
                    value: 'district_engineer'
                },
                {
                    text: this.$t('Период обслуживания с'),
                    value: 'date_begin'
                },
                {
                    text: this.$t('Период обслуживания по'),
                    value: 'date_end'
                }
            ];
        },
        KHLT() {
            return translate(this.KSKHousesList, 'full', this.$i18n.locale);
        },
        KSK() {
            if (!this.KSKFullInfo) return { ksk_name: null, bin: null, chairman: null, district_name: null, address_full_name: null };
            return translate(this.KSKFullInfo, 'full', this.$i18n.locale);
        },
        contacts() {
            return translate(this.KSKContacts, 'full', this.$i18n.locale);
        },
        kskHousesPagination: {
            get() {
                return this.KSKHousesPagination;
            },
            async set(val) {
                this.$store.commit('request/setKSKHousesPagination', val);
                if (this.KSKRid == 0) return;
                if (!this.Filter) {
                    const obj = {
                        ahs_ksk_rid: this.KSKRid
                    };

                    const processedArrayWithFilters = getFilterArray(obj);
                    if (processedArrayWithFilters.length > 0) {
                        let arrayFilter = {
                            where: [...processedArrayWithFilters]
                        };
                        this.$store.commit('request/setFilter', arrayFilter);
                    }
                }
                //console.log(this.Filter);
                await this.getKSKHouses({ KSKRid: this.KSKRid, iLimit: val.itemsPerPage, iOffset: val.itemsPerPage * (val.page - 1) });
            }
        }
    },
    methods: {
        ...mapActions('request', ['getKSKFullInfo', 'getKSKHouses', 'updateKSKInfo', 'getContactTypes']),
        ...mapActions('users', ['getUserInfo']),
        showNew() {
            this.$refs.addEditContact.openNew();
        },
        async onContactSave(savedData) {
            await this.updateKSKInfo({ iksk_rid: this.KSKRid, nvcKSKData: { contacts: [savedData] } });
            await this.getKSKFullInfo({ KSKId: this.KSKRid });
        }
    },
    async created() {
        this.$store.commit('request/setFilter', null);
        await this.getUserInfo();
        if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_ksk_rid) {
            this.KSKRid = this.userInfo.user_data.isas_ksk_rid;
        } else {
            this.KSKRid = 0;
        }

        this.$store.commit('request/setKSKHousesLoading', false);
        this.$store.commit('request/setKSKHousesList', []);
        this.$store.commit('request/setKSKHousesLenght', 0);
        await this.getKSKFullInfo({ KSKId: this.KSKRid });
        //await this.getKSKHouses({ KSKRid: this.KSKRid, iLimit: 10, iOffset: 0 });
        await this.getKSKHouses({ KSKRid: this.KSKRid, iLimit: 10, iOffset: 0 });
        await this.getContactTypes();
    }
};
</script>
